<template>
    <div v-if="loading" class="con-vs-loading vs-loading-background-transparent vs-loading-color-#fff">
      <div class="vs-loading default" style="transform: scale(0.45);">
        <div class="effect-1 effects" style="border-left: 3px solid rgb(255, 255, 255);"></div>
        <div class="effect-2 effects" style="border-left: 3px solid rgb(255, 255, 255);"></div>
        <div class="effect-3 effects" style="border-left: 3px solid rgb(255, 255, 255);"></div>
      </div>
    </div>
    <div v-else>
      <vx-card class="lg:p-8 w-full mb-6">
        <div class="flex justify-between">
          <div class="vx-card__title mb-4">
            <h2 class="mb-4">Редактирование</h2>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="Название: *"
              name="name"
              v-model="formData.name"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="Описание"
              name="description"
              v-model="formData.description"
            />
            <span class="text-danger text-sm" v-show="errors.has('description')">{{ errors.first('description') }}</span>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col flex items-center sm:w-1/2 w-full mb-6">
            <vs-checkbox
              class="w-full"
              name="enabled"
              v-model="formData.enabled"
            >
              Включен
            </vs-checkbox>
            <span class="text-danger text-sm" v-show="errors.has('enabled')">{{ errors.first('enabled') }}</span>
          </div>
        </div>

        <div v-for="(transport, key) in formData.transports" :key="key" class="vx-row items-center">
          <div class="vx-col sm:w-6/12 w-full mb-6">
            <label>
              <div class="vs-input--label">Доступные мессенджеры</div>
              <v-select
                v-model="transport.slug"
                name="transport_slug"
                :clearable="false"
                :reduce="option => option.value"
                :options="transportOptions"
                v-validate="'required'"
              />
            </label>
            <span class="text-danger text-sm" v-show="errors.has('transport_slug')">{{ errors.first('transport_slug') }}</span>
          </div>
          <div class="vx-col sm:w-3/12 w-full mb-6">
            <vs-input
              class="w-full"
              label="Имя в виджете"
              name="transport_name"
              v-model="transport.name"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('transport_name')">{{ errors.first('transport_name') }}</span>
          </div>
          <div class="vx-col sm:w-1/12 w-full">
            <vs-button
              class="mr-6 vs-con-loading__container"
              color="danger"
              icon-pack="feather"
              icon="icon-trash-2"
              @click="removeTransport(transport)"
            ></vs-button>
          </div>
        </div>

        <div class="vx-row pl-5" v-if="formData.transports.length < transportList.length">
          <vs-button
            class="vs-con-loading__container"
            color="dark"
            @click="addTransport"
          >
            {{ formData.transports.length > 0 ? 'Ещё один мессенджер' : 'Добавить мессенджер' }}
          </vs-button>
        </div>
      </vx-card>
      <vx-card class="lg:p-8 w-full mb-6">
        <div class="flex justify-between">
          <div class="vx-card__title mb-4">
            <h2 class="mb-4">Дополнительно</h2>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="Заголовок"
              name="title"
              v-model="formData.settings['dropdown.title']"
              v-validate="'required'"
            />
            <div class="text-sm">Заголовок виджета</div>
            <span class="text-danger text-sm" v-show="errors.has('title')">{{ errors.first('title') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <label>
              <div class="vs-input--label">Расположение на десктопе: *</div>
              <v-select
                v-model="formData.settings['orientation.desktop']"
                name="orientation_desktop"
                :clearable="false"
                :reduce="option => option.value"
                :options="orientationOptions"
                v-validate="'required'"
              />
            </label>
            <div class="text-sm">Варианты расположения виджета</div>
            <span class="text-danger text-sm" v-show="errors.has('orientation_desktop')">{{ errors.first('orientation_desktop') }}</span>
          </div>
        </div>
        <div class="vx-row">
            <div class="vx-col flex items-center sm:w-1/2 w-full mb-6">
              <vs-checkbox
                class="w-full"
                name="force"
                v-model="formData.settings['dropdown.force']"
              >
                Всегда показывать элементы в виде списка
              </vs-checkbox>
              <span class="text-danger text-sm" v-show="errors.has('force')">{{ errors.first('force') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-6">
              <label>
                  <div class="vs-input--label">Расположение на мобильном: *</div>
                  <v-select
                      v-model="formData.settings['orientation.mobile']"
                      name="orientation_mobile"
                      :clearable="false"
                      :reduce="option => option.value"
                      :options="orientationOptions"
                      v-validate="'required'"
                  />
              </label>
              <div class="text-sm">Варианты расположения виджета</div>
              <span class="text-danger text-sm" v-show="errors.has('orientation_mobile')">{{ errors.first('orientation_mobile') }}</span>
            </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <div class="flex items-center">
              <div class="mr-4">Автоматический отступ от краев</div>
              <vs-switch
                name="offset_auto"
                v-model="formData.settings['offset.auto']"
              />
              <span class="text-danger text-sm" v-show="errors.has('offset_auto')">{{ errors.first('offset_auto') }}</span>
            </div>
          </div>
        </div>

        <div class="vx-row" v-if="!formData.settings['offset.auto']">
            <div class="vx-col sm:w-1/4 w-full mb-6">
                <vs-input
                    class="w-full"
                    label="Десктоп"
                    name="offset_desktop_x"
                    v-model.number="formData.settings['offset.desktop'][0]"
                    v-validate="'decimal'"
                />
                <div class="text-sm">Отступ по горизонтали</div>
                <span class="text-danger text-sm" v-show="errors.has('offset_desktop_x')">{{ errors.first('offset_desktop_x') }}</span>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-6">
                <vs-input
                    class="w-full"
                    label=" "
                    name="offset_desktop_y"
                    v-model.number="formData.settings['offset.desktop'][1]"
                    v-validate="'decimal'"
                />
                <div class="text-sm">Отступ по вертиткали</div>
                <span class="text-danger text-sm" v-show="errors.has('offset_desktop_y')">{{ errors.first('offset_desktop_y') }}</span>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-6">
                <vs-input
                    class="w-full"
                    label="Мобильный"
                    name="offset_mobile_x"
                    v-model.number="formData.settings['offset.mobile'][0]"
                    v-validate="'decimal'"
                />
                <div class="text-sm">Отступ по горизонтали</div>
                <span class="text-danger text-sm" v-show="errors.has('offset_mobile_x')">{{ errors.first('offset_mobile_x') }}</span>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-6">
                <vs-input
                    class="w-full"
                    name="offset_mobile_y"
                    label=" "
                    v-model.number="formData.settings['offset.mobile'][1]"
                    v-validate="'decimal'"
                />
                <div class="text-sm">Отступ по вертиткали</div>
                <span class="text-danger text-sm" v-show="errors.has('offset_mobile_y')">{{ errors.first('offset_mobile_y') }}</span>
            </div>
        </div>

        <div class="flex justify-end mt-6">
            <vs-button
                class="vs-con-loading__container"
                :disabled="loading"
                @click="submit"
            >
                <div v-if="loading" class="con-vs-loading vs-loading-background-primary vs-loading-color-#fff">
                    <div class="vs-loading default" style="transform: scale(0.45);">
                    <div class="effect-1 effects" style="border-left: 3px solid rgb(255, 255, 255);"></div>
                    <div class="effect-2 effects" style="border-left: 3px solid rgb(255, 255, 255);"></div>
                    <div class="effect-3 effects" style="border-left: 3px solid rgb(255, 255, 255);"></div>
                    </div>
                </div>
                Сохранить
            </vs-button>
        </div>
      </vx-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import WidgetsService from '../../api/http/models/widgets/WidgetsService'

export default {
  data () {
    return {
      formData: {
        settings: {
          'orientation.mobile': '',
          'orientation.desktop': '',
          'dropdown.force': false,
          'dropdown.title': '',
          'offset.auto': true,
          'offset.mobile': [],
          'offset.desktop': []
        },
        enabled: false,
        transports: []
      },
      loading: false,
      transportList: []
    }
  },
  computed: {
    ...mapGetters(['authUserCompany']),
    orientationOptions () {
      return [
        {
          label: 'Левый верхний угол',
          value: 'top-left'
        },
        {
          label: 'Правый верхний угол',
          value: 'top-right'
        },
        {
          label: 'Левый нижний угол',
          value: 'bottom-left'
        },
        {
          label: 'Правый нижный угол',
          value: 'bottom-right'
        }
      ]
    },
    transportOptions () {
      return this.transportList.map(({ channel_name, slug }) => ({ label: channel_name, value: slug }))
    }
  },
  methods: {
    async submit () {
      const validate = await this.$validator.validateAll()

      if (validate) {
        try {
          this.loading = true
          const data = await WidgetsService.updateOne(this.authUserCompany.slug, this.$route.params.widgetSlug, this.formData)
          if (data.status === 'success') {
            this.$vs.notify({
              color: 'success',
              title: 'Настройки виджета сохранены',
              text: 'Изменение настроек виджета прошло успешно'
            })
            await this.$router.push({ name: 'widgets' })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Ошибка при изменении настроек виджета',
              text: ''
            })
          }
        } catch {
          this.$vs.notify({
            color: 'danger',
            title: 'Ошибка при изменении настроек виджета',
            text: ''
          })
        } finally {
          this.loading = false
        }
      }
    },

    addTransport () {
      if (this.formData.transports.length >= this.transportList.length) {
        return
      }

      this.formData.transports.push({
        name: '',
        slug: ''
      })
    },

    removeTransport (transportToRemove) {
      this.formData.transports = this.formData.transports.filter((transport) => transportToRemove !== transport)
    }
  },
  async created () {
    this.loading = true
    const [{ data: transportList }, { data: formData }] = await Promise.all([
      this.$api.Widgets.getTransports(this.authUserCompany.slug),
      this.$api.Widgets.getOne(this.authUserCompany.slug, this.$route.params.widgetSlug)
    ])

    this.transportList = transportList

    if (formData) {
      this.formData = formData
    }
    this.loading = false
  }
}
</script>
